import Vue from 'vue'
import Vuex from 'vuex'
import store from 'store'

import inv from './inv'

Vue.use(Vuex)

const getDefaultState = () => ({
  user: null,
  documentsRead: [],
  cgaValue: null,
})

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {

    USER (state, payload) {
      state.user = payload
    },

    DOCUMENTS_READ (state, payload) {
      state.documentsRead = payload
    },

    DOCUMENTS_READ_ADD (state, payload) {
      if (state.documentsRead.indexOf(Number(payload)) === -1) { state.documentsRead.push(Number(payload)) }
    },

    LOGOUT (state) {
      delete Vue.api.defaults.headers.common['Authorization']
      store.remove('token')
      Object.assign(state, getDefaultState())
    },

    SET_CGA_VALUE (state, value) {
      console.log('value' + value)
      state.cgaValue = value
    },

  },
  actions: {

    async getUser ({ commit }, token = null) {
      if (token) {
        store.set('token', token)
      } else {
        token = store.get('token')
      }
      if (!token) return
      Vue.api.defaults.headers.common['Authorization'] = 'Bearer ' + token

      const data = await Vue.api.get('/user')
      commit('USER', data.user)
      commit('DOCUMENTS_READ', data.documentsRead)
    },

    addDocument ({ commit }, id) {
      commit('DOCUMENTS_READ_ADD', id)
    },

    async setCgaValue ({ commit }, payload) {
      const { user, id, val } = payload
      await Vue.api.post(`/user/save-cga-json`, {
        user: user,
        id: id,
        value: val,
      })
      commit('SET_CGA_VALUE', val)
    },

    async getCgaValue ({ commit }, { user, id }) {
      try {
        const response = await Vue.api.get(`/user/getCgaValue?param1=${user}&param2=${id}`)
        const data = await response.cgaValue
        if (data !== undefined) {
          return data
        } else {
          throw new Error('La réponse ne contient pas de champ "cga".')
        }
      } catch (error) {
        console.error('Erreur lors de la récupération de la valeur cga:', error)
        throw error
      }
    },
  },
  modules: {
    inv,
  },
})
